import { motion } from "framer-motion";
import { Crosshair, ArrowUpRight } from "lucide-react";
import { IMAGES } from "../lib/images";
import { Reveal } from "./Reveal";

const points = [
  { k: "6", label: "Macchine dedicate alla rettifica" },
  { k: "INT · EXT", label: "Rettifica interni ed esterni" },
  { k: "N°9", label: "Reparto dedicato in Via Kennedy 9" },
];

export const Rettifica = () => (
  <section id="rettifica" data-testid="rettifica" className="border-t border-white/10 bg-black">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <div>
        <Reveal>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-red-600" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Nuova Divisione</span>
          </div>
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Acquisizione strategica nel modenese</span>
          <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none mt-4 mb-8">
            Divisione<br /><span className="text-red-600">Rettifica</span>
          </h2>
          <p className="text-lg text-zinc-400 leading-relaxed max-w-lg mb-10">
            Con l'acquisizione di un'affermata azienda di rettifiche del territorio modenese — e del prezioso
            <span className="text-white font-medium"> know-how del suo personale specializzato</span> — nasce la nostra
            nuova divisione di rettifica. Il civico numero 9 ospita oggi un reparto interamente dedicato con
            <span className="text-white font-medium"> 6 macchine per rettifica interni ed esterni</span>, che completano
            il nostro ciclo produttivo con una finitura ad alta precisione, internamente e senza compromessi.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {points.map((p, i) => (
            <Reveal key={p.label} delay={i * 0.1}>
              <div data-testid={`rettifica-point-${i}`} className="border-l border-white/15 pl-4">
                <div className="font-display font-black text-2xl md:text-3xl tracking-tight text-white">{p.k}</div>
                <div className="font-mono text-[11px] uppercase tracking-wider text-zinc-500 mt-2 leading-relaxed">{p.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15}>
        <motion.div whileHover={{ y: -6 }} className="group relative border border-white/10 overflow-hidden aspect-[4/5]">
          <img src={IMAGES.grinding} alt="Rettifica di precisione — reparto rettifiche" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
          <div className="absolute top-6 left-6 text-red-600"><Crosshair size={30} strokeWidth={1.4} /></div>
          <ArrowUpRight className="absolute top-6 right-6 text-white/40 group-hover:text-red-600 group-hover:rotate-45 transition-all duration-500" />
          <div className="absolute bottom-6 left-6 font-mono text-xs uppercase tracking-widest text-zinc-300">
            Finitura ad alta precisione · Tolleranze micrometriche
          </div>
        </motion.div>
      </Reveal>
    </div>
  </section>
);
